import { memo } from 'react';

import { UserRoundPlus, UsersRound } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/shadcn/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shadcn/tabs';

import { TestId } from '@/types/testId';
import { AddTeams } from './addTeams/addTeams';
import { AddUsers } from './addUsers/addUsers';

enum Tab {
  AddTeams = 'AddTeams',
  AddUsers = 'AddUsers'
}

type Props = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  groupName: string;
  submitAddUsers: (usersEmails: string[]) => void;
  submitAddTeams: (teamsAccountIds: number[]) => void;
};

export const AddParticipantsModal = memo(
  ({
    isOpen,
    onOpenChange,
    groupName,
    submitAddUsers,
    submitAddTeams
  }: Props) => (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add participants</DialogTitle>
        </DialogHeader>
        <Tabs className="w-full" defaultValue={Tab.AddTeams}>
          <TabsList className="grid w-full grid-cols-2 bg-background">
            <TabsTrigger
              data-testid={TestId.AddParticipantsModal.TeamsTab}
              value={Tab.AddTeams}
            >
              <UsersRound /> Add teams
            </TabsTrigger>
            <TabsTrigger
              data-testid={TestId.AddParticipantsModal.UsersTab}
              value={Tab.AddUsers}
            >
              <UserRoundPlus /> Add users
            </TabsTrigger>
          </TabsList>
          <TabsContent value={Tab.AddTeams}>
            <AddTeams groupName={groupName} submit={submitAddTeams} />
          </TabsContent>
          <TabsContent value={Tab.AddUsers}>
            <AddUsers submit={submitAddUsers} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  )
);
